export default {
  path: 'sys_post',
  name: 'sys_post',
  component: () => import('@/pages/sys_post/SysPost'),
  meta: { title: '岗位管理' },
}
